import React from "react";

import { ContainerBg } from "../../useGeneralStyles";
import Logs from "./components/Logs";

const RithmicFiles = (): React.ReactElement => {
  return (
    <div>
      <ContainerBg>
        <Logs folderPath="archive" title="Archive" />
        <Logs folderPath="errors" title="Errors" />
      </ContainerBg>
    </div>
  );
};

export default RithmicFiles;
